<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="3">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-ceria">
          <v-col class="d-flex justify-start align-center">
            <v-icon size="30" color="#40a939">mdi-account-group-outline</v-icon>
            <div class="font-size-11 text-center black--text text-capitalize ml-3"><strong style="color: #40a939;">Mitra Ceria</strong></div>
          </v-col>
          <hr class="my-1" style="filter: opacity(0.35);">

          <v-card-text>
            <v-row>
              <v-col cols="12" lg="12">
                <div class="d-flex flex-row align-center justify-space-between">
                  <label class="font-weight-bold">Total<br>Member</label>
                  <h1 class="mt-3">
                    <div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(totalDownline.total_kiri_ceria) + parseInt(totalDownline.total_kanan_ceria)) | toNumber }}</div>
                  </h1>
                </div>
              </v-col>

              <v-col cols="12" lg="6" class="d-flex align-start flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #40a939;">{{ totalDownline.total_kiri_ceria | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Titik Kiri</div>
              </v-col>
              
              <v-col cols="12" lg="6" class="d-flex align-end flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #40a939;">{{ totalDownline.total_kanan_ceria | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize">Titik Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" sm="12" md="6" lg="3">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-ekonomi">
          <v-col class="d-flex justify-start align-center">
            <v-icon size="30" color="#ad0757">mdi-account-group-outline</v-icon>
            <div class="font-size-11 text-center black--text text-capitalize ml-3"><strong style="color: #ad0757;">Mitra Ekonomis</strong></div>
          </v-col>
          <hr class="my-1" style="filter: opacity(0.35);">

          <v-card-text>
            <v-row>
              <v-col cols="12" lg="12">
                <div class="d-flex flex-row align-center justify-space-between">
                  <label class="font-weight-bold">Total<br>Member</label>
                  <h1 class="mt-3">
                    <div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(totalDownline.total_kiri_ekonomi) + parseInt(totalDownline.total_kanan_ekonomi)) | toNumber }}</div>
                  </h1>
                </div>
              </v-col>

              <v-col cols="12" lg="6" class="d-flex align-start flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #ad0757;">{{ totalDownline.total_kiri_ekonomi | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Titik Kiri</div>
              </v-col>
              
              <v-col cols="12" lg="6" class="d-flex align-end flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #ad0757;">{{ totalDownline.total_kanan_ekonomi | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize">Titik Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="3">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-premium">
          <v-col class="d-flex justify-start align-center">
            <v-icon size="30" color="#2a4fd6">mdi-account-group-outline</v-icon>
            <div class="font-size-11 text-center black--text text-capitalize ml-3"><strong style="color: #2a4fd6;">Mitra Premium</strong></div>
          </v-col>
          <hr class="my-1" style="filter: opacity(0.35);">

          <v-card-text>
            <v-row>
              <v-col cols="12" lg="12">
                <div class="d-flex flex-row align-center justify-space-between">
                  <label class="font-weight-bold">Total<br>Member</label>
                  <h1 class="mt-3">
                    <div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(totalDownline.total_kiri) + parseInt(totalDownline.total_kanan)) | toNumber }}</div>
                  </h1>
                </div>
              </v-col>

              <v-col cols="12" lg="6" class="d-flex align-start flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #2a4fd6;">{{ totalDownline.total_kiri | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Titik Kiri</div>
              </v-col>
              
              <v-col cols="12" lg="6" class="d-flex align-end flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #2a4fd6;">{{ totalDownline.total_kanan | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize">Titik Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" sm="12" md="6" lg="3">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-supreme">
          <v-col class="d-flex justify-start align-center">
            <v-icon size="30" color="#9b141b">mdi-account-group-outline</v-icon>
            <div class="font-size-11 text-center black--text text-capitalize ml-3"><strong style="color: #9b141b;">Mitra Supreme</strong></div>
          </v-col>
          <hr class="my-1" style="filter: opacity(0.35);">

          <v-card-text>
            <v-row>
              <v-col cols="12" lg="12">
                <div class="d-flex flex-row align-center justify-space-between">
                  <label class="font-weight-bold">Total<br>Member</label>
                  <h1 class="mt-3">
                    <div class="text-center font-weight-bold" style="color: #000;">{{ (parseInt(totalDownline.total_kiri_supreme) + parseInt(totalDownline.total_kanan_supreme)) | toNumber }}</div>
                  </h1>
                </div>
              </v-col>

              <v-col cols="12" lg="6" class="d-flex align-start flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #9b141b;">{{ totalDownline.total_kiri_supreme | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Titik Kiri</div>
              </v-col>
              
              <v-col cols="12" lg="6" class="d-flex align-end flex-column">
                <h3 class="">
                  <div class="text-center font-weight-500" style="color: #9b141b;">{{ totalDownline.total_kanan_supreme | toNumber }}</div>
                </h3>
                <div class="font-size-9 text-center text--black text-capitalize">Titik Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="4"  md="4">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-ro">
          <v-col class="d-flex justify-center">
            <v-icon size="40" color="#fca800">mdi-cart-plus</v-icon>
          </v-col>
          <div class="font-size-11 text-center text--black text-capitalize ml-1"><v-icon dense class="mr-1">mdi-arrow-left-thick</v-icon>Mitra Kiri<br><strong class="black--text">RO Ekonomis</strong></div>
          <h2 class="mb-3">
            <div class="text-center font-weight-500" style="color: #fca800;">{{ totalDownline.total_kiri_repeat_order | toNumber }}</div>
          </h2>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4"  md="4">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-ro">
          <v-col class="d-flex justify-center">
            <v-icon size="40" color="#fca800">mdi-cart-plus</v-icon>
          </v-col>
          <div class="font-size-11 text-center text--black text-capitalize ml-1">Mitra Kanan<v-icon dense class="ml-1">mdi-arrow-right-thick</v-icon><br><strong class="black--text">RO Ekonomis</strong></div>
          <h2 class="mb-3">
            <div class="text-center font-weight-500" style="color: #fca800;">{{ totalDownline.total_kanan_repeat_order | toNumber }}</div>
          </h2>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4"  md="4">
        <v-card class="pa-1 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth card-ro">
          <v-col class="d-flex justify-center">
            <v-icon size="40" color="#fca800">mdi-cart-plus</v-icon>
          </v-col>
          <div class="font-size-11 text-center text--black text-capitalize ml-1">Total Mitra<br><strong class="black--text">RO Ekonomis</strong></div>
          <h2 class="mb-3">
            <div class="text-center font-weight-500" style="color: #fca800;">{{ totalDownline.total_repeat_order | toNumber }}</div>
          </h2>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  props: {
    totalDownline: Object
  }
}
</script>

<style>
  .card-supreme {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,f4d2d4+100 */
    background: linear-gradient(to bottom,  rgba(254,255,255,1) 0%,rgb(237 140 146) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
  
  .card-premium {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,c0c4d3+100 */
    background: linear-gradient(to bottom,  rgba(254,255,255,1) 0%,rgb(199 210 248) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
  .card-ekonomi {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,ad0757+100&1+0,0.18+100 */
    background: linear-gradient(to bottom,  rgba(254,255,255,1) 0%,rgb(255 0 123 / 32%) 100%) /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

  .card-ceria {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,168d0d+100&1+0,0.18+100 */
    background: linear-gradient(to bottom,  rgba(254,255,255,1) 0%,rgba(22,141,13,0.18) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

  .card-ro {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#feffff+0,fca800+100&1+0,0.1+100 */
    background: linear-gradient(to bottom,  rgba(254,255,255,1) 0%,rgba(252,168,0,0.1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
</style>